import React from 'react';
import Spinner from '../Spinner/Spinner';
import { OnboardingIntro } from './OnboardingIntro/OnboardingIntro';
import { OnboardingState } from '../../types/onboarding/survey';
import { ROUTES } from '../../utils/routes';
import { navigateWithReload } from '../../utils';
import { STORAGE_KEYS } from '../../utils/storage';
import { useAuth } from '../../contexts';

interface OnboardingStatesProps {
  state: OnboardingState;
  showIntroHandler: () => void;
  isReactivated?: boolean;
}

export const OnboardingStates: React.FC<OnboardingStatesProps> = ({
  state,
  showIntroHandler,
  isReactivated = false,
}) => {
  const { loader, error, showIntro, onboardingFinished } = state;
  const { signed } = useAuth();
  const onboardingData = localStorage.getItem(STORAGE_KEYS.ONBOARDING_DATA);
  if (loader) {
    return <Spinner isDark />;
  }

  if (error) {
    return <p>Sorry, the survey is temporarily unavailable.</p>;
  }

  if (showIntro) {
    return <OnboardingIntro isReactivation={isReactivated} onStartNow={showIntroHandler} />;
  }

  if ((!!onboardingData || onboardingFinished) && signed) {
    navigateWithReload(ROUTES.RECOMMENDEDPROGRAM);
  }

  if ((!!onboardingData || onboardingFinished) && !signed) {
    navigateWithReload(ROUTES.CREATEACCOUNT);
  }

  return null;
};
